import Swiper from "swiper/bundle";

const Home = {
  init() {
    Home.heroSlider();
    Home.newsSlider();
  },

  heroSlider() {
    let swiper_banner = new Swiper(".banner__slider", {
      slidesPerView: 1,
      //loop: true,
      navigation: {
        nextEl: ".arrow--right",
        prevEl: ".arrow--left",
      },
    });
  },

  newsSlider() {
    //swiper slider
    let swiper_news = new Swiper(".news__slider", {
      slidesPerView: 1,
      spaceBetween: 108,
      navigation: {
        nextEl: ".arrow--right",
        prevEl: ".arrow--left",
      },
    });
  },
};

export default Home;
